import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';
import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import typographyStyles from 'craft/resolvers/Typography/constants';
import { CommonNodeProperties } from 'craft/types';

interface Props {
  nodeIds: string[];
}

export const TypographyVariantSelector = ({ nodeIds }: Props) => {
  const {
    css,
    custom,
    actions: { setCustom },
  } = useMultiNodes(
    nodeIds,
    (node) => ({
      custom: node?.data.custom?.custom ?? {},
      css: node?.data.custom?.css ?? {},
    }),
    CommonNodeProperties.Multiple,
  );
  // when switching variant, we reset some css properties
  const { textAlign, color, fontSize, ...customCss } = css;

  const changeVariant = (variant: VariantNode) => {
    const conditionVariant = variant.conditions.variant;
    const variantCss = (typographyStyles as any)[conditionVariant] || typographyStyles.P;
    setCustom({
      custom: variant.conditions,
      css: { ...customCss, ...variantCss, textAlign },
    });
  };
  const variantId = custom.variation || custom.variant;
  return (
    <Variants
      name={variantId}
      componentName="Typography"
      onSelectVariant={changeVariant}
      conditions={custom}
    />
  );
};
